export default "__VITE_ASSET__B$jcAVM4__"